import { Box, Grid } from "@mui/material";
import { sectionWrapperSx } from "./sectionWrapper";
import { useMediaQuery } from "@mui/system";
import { debtsRequests } from "api/debtsApi";
import { settings } from "app";
import React, { useCallback, useEffect, useState } from "react";
import { Datagrid, DateField, NumberField, SelectField, TextField } from "react-admin";
import dataProvider from "server/dataProvider";
import { DebtStatusChoices } from "utils/choices";
import DebtTransactionsDialog from "./DebtTransactionsDialog";

const PaymentHistory = ({ userUId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [paymentHistory, setPaymentHistory] = useState([]);

  const fetchPaymentHistory = useCallback(async () => {
    if (!userUId) return;
    try {
      const { data } = await dataProvider.customRequest(debtsRequests.getUserDebtsById(userUId), null, "GET");
      setPaymentHistory(data || []);
    } catch (err) {
      setPaymentHistory([]);
      console.error(err);
    }
  }, [userUId]);

  useEffect(() => {
    fetchPaymentHistory();
  }, [fetchPaymentHistory]);

  return (
    <Box sx={sectionWrapperSx}>
      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <Datagrid
            data={paymentHistory}
            rowClick={false}
            bulkActionButtons={false}
            resource="paymentHistory"
            sx={{ margin: 2, ...settings.style.secondaryDatagrid }}
          >
            <TextField
              label="Вид"
              source="typeName"
              sortable={false}
            />
            <DateField
              label="Дата"
              source="createdAt"
              showTime
              sortable={false}
              locales="bg-BG"
            />
            <NumberField
              label="Сума"
              source="amount"
              options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
              sortable={false}
            />
            <TextField
              label="Валута"
              source="currencyText"
              sortable={false}
            />
            <SelectField
              label="Статус"
              source="status"
              choices={DebtStatusChoices}
              sortable={false}
            />
            <DebtTransactionsDialog />
          </Datagrid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentHistory;
